import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ProjectSubTypeApiModel } from "@/core/models/api/project-sub-type-api-model.model";
import { SubprojectTypeService } from "@/core/services/subproject-type.service";
import { ProjectSubTypeActions } from "./project-subtype.actions";

@Injectable()
export class ProjectSubtypeEffects {
    actions$ = inject(Actions);
    subprojectTypeService = inject(SubprojectTypeService);

    constructor(){

    }

    _loadProjectSubtype = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectSubTypeActions.loadProjectSubTypes),
            exhaustMap(() => {
                return this.subprojectTypeService.getAll().pipe(
                    map((response: any) => {
                        const projectSubTypes = response as ProjectSubTypeApiModel[];
                        return ProjectSubTypeActions.loadProjectSubTypeSuccess({ projectSubTypes });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of(ProjectSubTypeActions.loadProjectSubTypeFail({ error: error.message }));
                    })
                )
            })
        )
    })

    _addProjectSubtype = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectSubTypeActions.addProjectSubType),
            exhaustMap((action) => {
                return this.subprojectTypeService.add(action.projectSubType).pipe(
                    map((response: any) => {
                        const projectSubType = response as ProjectSubTypeApiModel;
                        return ProjectSubTypeActions.addProjectSubTypeSuccess({ projectSubType });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _updateProjectSubtype = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectSubTypeActions.updateProjectSubType),
            exhaustMap((action) => {
                return this.subprojectTypeService.update(action.projectSubType).pipe(
                    map((response: any) => {
                        const projectSubType = response as ProjectSubTypeApiModel;
                        return ProjectSubTypeActions.updateProjectSubTypeSuccess({ projectSubType });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _deleteProjectSubtype = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectSubTypeActions.deleteProjectSubType),
            exhaustMap((action) => {
                return this.subprojectTypeService.delete(action.projectSubTypeId).pipe(
                    map((response: any) => {
                        return ProjectSubTypeActions.deleteProjectSubType({ projectSubTypeId : action.projectSubTypeId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}